var LocationVariant = /* @__PURE__ */ ((LocationVariant2) => {
  LocationVariant2["ListItem"] = "ListItem";
  LocationVariant2["StandAlone"] = "StandAlone";
  LocationVariant2["MapItem"] = "MapItem";
  return LocationVariant2;
})(LocationVariant || {});
export {
  LocationVariant
};
//# sourceMappingURL=types.js.map
